export class CredentialType {

  static CERTIFICATE = "CertificateCredential";
  static USERNAME_PASSWORD = "UserNameAndPasswordCredential";
  static USERNAME_PASSWORD_TOKEN = "UserNameAndPasswordWithTokenCredential";

  static Certificate = new CredentialType(CredentialType.CERTIFICATE, "Certificate");

  static UserNameAndPassword = new CredentialType(CredentialType.USERNAME_PASSWORD, "Username Password");
  static UserNameAndPasswordWithToken = new CredentialType(CredentialType.USERNAME_PASSWORD_TOKEN, "Grant Authority", true);

  constructor(readonly name: string, readonly friendlyName: string, readonly isHidden: boolean = false) { }

  static readonly all: CredentialType[] = [
    CredentialType.UserNameAndPassword,
    CredentialType.Certificate,
  ];
  private static readonly allInternal: CredentialType[] = [
    CredentialType.UserNameAndPassword,
    CredentialType.Certificate,
    CredentialType.UserNameAndPasswordWithToken
  ];
  static tryParse(name: string): CredentialType {
      const result = CredentialType.allInternal.find(x => x.name === name);
      return result ? result : null;
  }
}
